<template>
  <div class="c-right host-topology-c-right" :class="{'bl-none': isEmpty(hosts) }">
    <ul class="list">
      <li class="item d-flex" v-for="(host, nidx) in account.hosts" :key="nidx">
        <res-host :dataSource="dataSource" :host="host" :isLast="nidx === account.hosts.length - 1" @click="(e) => handleHostClick(e, nidx)" />
        <template v-if="host.isChildrenShow">
          <ul class="list">
            <li class="item d-flex">
              <div v-for="(obj, idx) in host.servers" :key="idx">
                <res-common
                  type="vminstance"
                  :isLast="idx === host.servers.length - 1"
                  :dataSource="obj"
                  :schedTagColorsMap="schedTagColorsMap"
                  :showStorageTag="true"
                  :extraShowList="getServerInfoList(obj)" />
              </div>
            </li>
            <li class="item d-flex">
              <div v-for="(obj, idx) in host.isolate_devices" :key="idx">
                <res-common
                  type="gpu"
                  :showLeftLine="host.servers && host.servers.length && idx === 0"
                  :isLast="idx === host.isolate_devices.length - 1"
                  :dataSource="obj"
                  :schedTagColorsMap="schedTagColorsMap"
                  :showStorageTag="true" />
              </div>
            </li>
          </ul>
        </template>
        <div v-if="host.isolate_devices && host.isolate_devices.length && host.isChildrenShow" class="host-left-line" />
      </li>
    </ul>
  </div>
</template>

<script>
import { KVM_SHARE_STORAGES } from '@/constants/storage'
import { RES_ICON_MAP } from '@Network/sections/Topology/constants'
import ResMixin from '@Network/sections/Topology/ResMixin'
import ResHost from '../ResHost'
import ResCommon from '../ResCommon'

const COLORS = ['#E45826', '#874356', '#0E3EDA', '#139487', '#464E2E', '#A1B57D', '#6E3CBC', '#6FB2D2', '#C5D8A4', '#F473B9', '#D18CE0', '#203239']

export default {
  name: 'AccountTopology',
  components: {
    ResHost,
    ResCommon,
  },
  mixins: [ResMixin],
  props: {
    classic: Boolean,
    physical: Boolean,
    dataSource: Object,
    account: Object,
    initExpand: Number,
  },
  data () {
    return {
      RES_ICON_MAP,
      serverVisible: [],
    }
  },
  computed: {
    wires () {
      return this.account?.wires || []
    },
    networks () {
      let networks = []
      if (this.account) {
        this.account.wires.forEach(v => {
          if (v.networks && v.networks.length > 0) {
            networks = networks.concat(v.networks.filter(v => v.server_type === 'guest'))
          }
        })
      }
      return networks
    },
    schedTagColorsMap () {
      const ret = {}
      let index = 0
      const { wires = [], hosts = [] } = this.account
      const originWires = wires.length ? wires : [{ hosts }]
      originWires.map(wire => {
        const { hosts = [] } = wire
        hosts.map(host => {
          const { schedtags = [] } = host
          schedtags.map(schedtag => {
            if (schedtag.name && !ret[schedtag.name]) {
              ret[schedtag.name] = COLORS[index % COLORS.length]
              index++
            }
          })
        })
      })
      return ret
    },
  },
  watch: {
    initExpand (val) {
      this.serverVisible = (this.account?.hosts || []).map(item => {
        return val % 2 === 1
      })
    },
  },
  methods: {
    getMultiple (nidx, resArr, curObj) {
      if (this.physical) {
        if (resArr[nidx + 1]) {
          return resArr[nidx + 1].hosts.some((v, i) => {
            if (v.id === undefined || curObj.id === undefined) return false
            if (v.id === curObj.id) {
              resArr[nidx + 1].hosts[i].hidden = true
            }
            return v.id === curObj.id
          })
        }
      } else {
        if (resArr[nidx + 1]) {
          return resArr[nidx + 1].address.some((v, i) => {
            if (v.owner_id === undefined || curObj.owner_id === undefined) return false
            if (v.owner_id === curObj.owner_id) {
              resArr[nidx + 1].address[i].hidden = true
            }
            return v.owner_id === curObj.owner_id
          })
        }
      }
      return false
    },
    getHost (wire) {
      const resTypes = ['hypervisor', 'hosts', 'baremetal', 'esxi']
      return wire.hosts?.filter(v => resTypes.includes(v.host_type))
    },
    getAddress (network) {
      const resTypes = ['servers', 'hosts', 'loadbalancers', 'dbinstances']
      return network.address?.filter(v => resTypes.includes(v.owner_type))
    },
    isHostExist (wires, nidx, host) {
      let isExist = false

      // 跨 wire 查找
      for (let i = nidx - 1; i >= 0; i--) {
        const wire = wires[i]
        if (wire.hosts && wire.hosts.length > 0) {
          const hostArr = this.getHost(wire)
          isExist = hostArr.some(v => v.id === host.id)
          if (isExist) return true
        }
      }

      return isExist
    },
    isAddrExist (networks, nidx, addr) {
      let isExist = false

      // 跨 networks 查找
      for (let i = nidx - 1; i >= 0; i--) {
        const network = networks[i]
        if (network.address && network.address.length > 0) {
          const addressArr = this.getAddress(network)
          isExist = addressArr.some(v => v.owner_id === addr.owner_id)
        }
      }

      return isExist
    },
    getShareStoragesAndHosts (wires) {
      const shareStorages = []
      const storageHosts = []

      for (const wire of wires) {
        if (wire.hosts && wire.hosts.length > 0) {
          const hosts = []
          for (const host of wire.hosts) {
            if (host.storages && host.storages.length > 0) {
              for (const storage of host.storages) {
                const isExsit = shareStorages.find(item => item.storage.id === storage.id)
                if (KVM_SHARE_STORAGES.includes(storage.storage_type)) {
                  hosts.push(host)
                  storageHosts.push({ key: storage.id, value: hosts })
                  !isExsit && shareStorages.push({ storage })
                }
              }
            }
          }
        }
      }

      return [shareStorages, storageHosts]
    },
    getShareStorages (wires) {
      return this.getShareStoragesAndHosts(wires)[0]
    },
    getHosts (wires, storageId) {
      const storageHosts = this.getShareStoragesAndHosts(wires)[1]
      const originHosts = []
      const hosts = storageHosts.filter(item => item.key === storageId).map(item => item.value).flat()
      hosts.forEach(item => {
        const isExist = originHosts.find(v => v.id === item.id)
        !isExist && originHosts.push(item)
      })
      return originHosts
    },
    getServerInfoList (data) {
      const { instance_type, tenant, isolate_devices = [] } = data
      return [
        { label: this.$t('compute.text_295'), value: instance_type },
        { label: this.$t('dictionary.project'), value: tenant },
        { label: this.$t('compute.passthrough_device_count'), value: isolate_devices.length },
      ]
    },
    handleHostClick (e, index) {
      this.$set(this.account.hosts[index], 'isChildrenShow', !this.account.hosts[index].isChildrenShow)
    },
  },
}
</script>

<style lang="scss" scoped>
// @import "@Network/sections/Topology/index.scss";
.c-left {
  width: 100px;
  display: flex;
  .line {
    height: 0px;
    width: 100%;
    border: 1px solid #2D3A4D;
  }
}
.host-topology-c-right {
  position: relative;
  &::after {
    height: 118px !important;
  }
}
// .host-left-line {
//   width: 2px;
//   height: 200px;
//   position: absolute;
//   left: 5px;
//   top: 200px;
//   background: red;
// }
</style>
